import React, { useEffect, useState } from "react";
import { Stack, Typography, Button } from "@mui/material";
import { useZxing } from "react-zxing";
import { toast } from "react-toastify";
import { ApiUrls } from "services/utils/globalVariables";
import useFetch from "services/hooks/useFetch";
import { dispatchHandler, useContextDispatch } from "services/context/MainContext";
import { actionTypes } from "services/context/reducer";

export default function BarcodePage() {

    const [{}, doCustomerFetch] = useFetch(ApiUrls.GetCustomerInfo, "get")
    const [{ response: res2, isLoading: load2, error: statusError }, doVerifyFetch] = useFetch(ApiUrls.VerifyCode, "post")

    const [load, setLoad] = useState(true)
    const [isPaused, setIsPaused] = useState(false)

    const dispatch = useContextDispatch()
    const { GET_USERINFO } = actionTypes
    
    const { ref } = useZxing({
        onDecodeResult(result) {
            //get code then send it to an API
            if(load) {
                doVerifyFetch({"Code": (result.getText().split("="))[1]}, handleRefreshInfo)
            }
        },
        timeBetweenDecodingAttempts: 3000
    })
    
    //Handle status of code after scan
    useEffect(() => {
        if(load2) {
            if(statusError) {
                toast.error(JSON.parse(statusError.response.data.Message).Exception)
            }
            if(res2) {
                toast.success(`${res2.Data.Message} امتیاز ثبت شده : ${res2.Data.Point}`)
                doCustomerFetch(null, handleRefreshInfo)
            }
        }
    }, [load2])
    
    useEffect(() => {
        if(!load) {
            setLoad(true)
        }
    }, [load])

    //Call customer info again for gain latest point data
    const handleRefreshInfo = (res) => {
        dispatchHandler(dispatch, GET_USERINFO, {userInfo: res.Data})
        setLoad(false)
    }

    return (
        <Stack 
            className="BarcodeScanner"
            sx={{width: "100%", height: "calc(100dvh - 140px)"}} 
            justifyContent="center" 
            alignItems="center"
        >
            <video ref={ref} />
        </Stack>
    )
}